import { RECAPTCHA_SITE_KEY } from "@shared/config";
import Script from "next/script";

export function RecaptchaScript() {
  return (
    <Script
      src={`https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_SITE_KEY}`}
    />
  );
}
